import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { EventApplicationService } from "../../../../services";
import * as CONSTANTS from "../../../../redux/Models/Application/constants";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { TraderUnitService } from "../../../../services";
import { Modal, Button } from "react-bootstrap";

import { DocumentTypeService } from "../../../../services";
import { handleConsoleError } from "../../../../utils/common-methods";

const FoodHyigeneHealth = () => {
  const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();

  const eventApplicationCatersId = getValues("caterApplicationFormData.id");

  const [rating, setRatingDoc] = useState();
  const [registered, setRegisteredDoc] = useState();
  const { eventId } = useParams();
  const [documentList, setDocumentList] = useState([]);
  const [documentList1, setDocumentList1] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [matchedDocument, setMatchedDocument] = useState(null);
  const [documentFor, setdocumentFor] = useState();
  const selectedTraderUnit = TraderUnitService.getSelectedTraderUnit();

  const handleDelete = async (doc) => {
    try {
      if (doc.originalId) {
        let response;
        response = await EventApplicationService.removeCaterApplicationDoc(
          doc.originalId
        );

        if (response?.isSuccess) {
          setValue(doc.id, "");
          await getTraderUnitDocument(selectedTraderUnit?.id);
          toast.success(response?.message);
        } else {
          toast.error(response?.message);
        }
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  //******* Event Application By EventID  *********
  const getEventApplicationByEventId = async () => {
    try {
      if (eventId) {
        const res = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          "C"
        );
        if (res?.isSuccess && res?.data) {
          const requiredDocumentsString = res?.data?.[0]?.requiredDocuments || "";

          const requiredDocuments = requiredDocumentsString
            .split(",")
            .map((id) => id.trim());
          await getActiveDocumentTypes(requiredDocuments);
        }
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  //********* Active Document List ***********
  const getActiveDocumentTypes = async (requiredDoc) => {
    try {
      const response = await DocumentTypeService.getActiveDocumentTypeList();
      if (response?.isSuccess) {
        const filteredDocuments = response?.data?.filter((doc) =>
          requiredDoc?.includes(doc.id)
        );
        const res = await EventApplicationService.getCaterApplicationById(
          eventApplicationCatersId
        );

        if (res?.isSuccess) {
          const uploadedDoc = res?.data?.objEventAppCatersDocModel;
          uploadedDoc.map((item) => {
            if (item.docTitle === CONSTANTS.CATER_RATING_DOC) {
              setRatingDoc(item?.docPath);
              setValue("rating", item?.docPath);
            }
            if (item.docTitle === CONSTANTS.CATER_REGISTERED_DOC) {
              setRegisteredDoc(item?.docPath);
              setValue("registered", item?.docPath);
            }
            return item;
          });

          const docs = filteredDocuments.map((x) => {
            const update = uploadedDoc.find(
              (obj) => obj.documentTypeId === x.id
            );
            if (update) {
              x.docPath = update?.docPath;
              x.originalId = update?.id;
            }
            return x;
          });
          docs.map((x) => {
            setValue(x.id, "");
            return x;
          });
          setDocumentList(docs);
        }
        // else{
        //    toast.error(
        //             res?.message || res?.Errors?.[0]?.Message || "Something went wrong",
        //           );
        // }

        setDocumentList(filteredDocuments);
      }
    } catch (error) {
       const message = handleConsoleError(error);
            toast.error(error?.message || message);
    }
  };

  //********* TraderUnit Document List ************
  const getTraderUnitDocument = async (unitId) => {
    try {
      await getDocumentTypes();
      const res = await TraderUnitService.getDocumentByTraderUnitId(unitId);
      if (res?.isSuccess && res?.data.length > 0) {
        setDocumentList1(res?.data);
      } else {
        setDocumentList1([]);
      }
    } catch (error) {
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleInputClick = (id) => {
    setSelectedDocumentType(id);
    setdocumentFor(id);
    const matched = documentList1.find(
      (documentsType) => documentsType.documentsType === id
    );

    if (matched) {
      setMatchedDocument(matched);
    } else {
      setMatchedDocument(null);
    }
    setShowModal(true); // Open the modal when the input is clicked
  };

  const onClose = () => {
    setShowModal(false);
  };

  const getDocumentTypes = async () => {
    try {
      const response = await DocumentTypeService.getDocumentTypeList();
      if (response?.isSuccess) {
        const dataTypes = response?.data.filter((doc) => doc.isActive);
        setDocumentTypes(dataTypes || []);
        await getEventApplicationByEventId();
      }
    } catch (error) {
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleDocumentTypeChange = (e) => {
    const selectedId = e.target.value;
    setSelectedDocumentType(selectedId);
    const matched = documentList1.find(
      (documentsType) => documentsType.documentsType === selectedId
    );
    if (matched) {
      setMatchedDocument(matched);
    } else {
      setMatchedDocument(null);
    }
  };

  const setRequiredDoc = (selectedDoc) => {
    if (selectedDoc.documentsType === documentFor) {
      setSelectedDocument([
        ...selectedDocument,
        ...[
          {
            documentFor: documentFor,
            documentsType: selectedDoc?.documentsType,
            documentName: selectedDoc?.documentName,
            id: selectedDoc?.id,
          },
        ],
      ]);
      setValue(`doc`, [
        ...selectedDocument,
        ...[
          {
            documentFor: documentFor,
            documentsType: selectedDoc?.documentsType,
            documentName: selectedDoc?.documentName,
            id: selectedDoc?.id,
          },
        ],
      ]);
      console.log();
      onClose();
    }
  };
  const getDocumentNamebyType = (documentsType) => {
    const doc =
      selectedDocument &&
      selectedDocument.find((x) => x.documentFor === documentsType);

    if (doc) {
      setValue(documentsType, doc?.documentName);
    }

    return doc && doc?.documentName;
  };

  useEffect(() => {
    getTraderUnitDocument(selectedTraderUnit?.id);
  }, []);

  const IsOptionalDoc = (docName) => {
    const keywords = ["gas", "electric", "personal"];
    return keywords.some((keyword) =>
      docName.toLowerCase().includes(keyword.toLowerCase())
    );
  };

  return (
    <React.Fragment>
      <h3 className="mb-3">Food Hyigene Health</h3>
      <React.Fragment>
        <Form.Control type="hidden" {...register("docList")} />
        <div>
          {" "}
          <span>(Only pdf and image files are allowed with max size 20MB)</span>
        </div>
        <div className="trader-booking-f mb-3">
          <Form.Group controlId="rating">
            <Form.Label>
              Most recent National Food Hygiene Rating Scheme Score (minimum 4)
              relevant to the named unit.{" "}
            </Form.Label>
            <Form.Control
              className="effect-4"
              type="text"
              {...register("rating", {
                required:
                  "Please enter most recent National Food Hygiene Rating Scheme Score (minimum 4)relevant to the named unit.",
                validate: (value) =>
                  value >= 4 || "Number must be greater than or equal to 4",
              })}
              defaultValue={rating}
            />
            <span className="focus-border"></span>
          </Form.Group>
        </div>
        {errors?.rating && (
          <span className="text-danger">{errors?.rating?.message}</span>
        )}
      </React.Fragment>
      <React.Fragment>
        <div className="trader-booking-f mb-3">
          <Form.Group controlId="registered">
            <Form.Label>
              Please specify which local authority your unit is registered with{" "}
            </Form.Label>
            <Form.Control
              className="effect-4"
              type="text"
              {...register("registered", {
                required:
                  "Please specify which local authority your unit is registered with.",
              })}
              defaultValue={registered}
            />
            <span className="focus-border"></span>
          </Form.Group>
        </div>
        {errors?.registered && (
          <span className="text-danger">{errors?.registered?.message}</span>
        )}
      </React.Fragment>
      {/* )} */}
      {documentList?.map((doc, index) => (
        <React.Fragment key={index}>
          {doc.docPath && (
            <React.Fragment>
              <div className="mb-3">
                <span className="mb-3">{doc?.documentName} </span>

                <div className="delete-food">
                  {doc.documentName && (
                    <a
                      href={doc.docPath}
                      target="_blank"
                      rel="noreferrer"
                      style={{ marginRight: "10px" }}
                    >
                      <i className="fa fa-eye"></i>
                    </a>
                  )}
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      handleDelete(doc);
                    }}
                    style={{ marginRight: "10px" }}
                  >
                    <i className="ri-delete-bin-line"></i>
                  </Link>
                </div>
              </div>
            </React.Fragment>
          )}
          {!doc.docPath && (
            <React.Fragment>
              <div className="trader-booking-f mb-3">
                <Form.Group controlId={doc.id}>
                  {IsOptionalDoc(doc?.documentName) && (
                    <>
                      <Form.Label key={index}>
                        {doc?.documentName} <span>(Optional)</span>
                      </Form.Label>
                      <Form.Control
                        key={index}
                        className="effect-4 mt-3"
                        type="text"
                        {...register(doc.id)}
                        readOnly
                        value={getDocumentNamebyType(doc?.id)}
                      />
                      <p className="mt-0 mb-0">
                        By not uploading this information, you are confirming
                        the document is not required in order to enable your
                        business to trade
                      </p>
                    </>
                  )}
                  {!IsOptionalDoc(doc?.documentName) && (
                    <>
                      <Form.Label key={index}>
                        {doc?.documentName}{" "}
                        <span className="text-danger">*</span>
                      </Form.Label>
                      <Form.Control
                        key={index}
                        className="effect-4 mt-3"
                        type="text"
                        {...register(doc.id, {
                          required: `Please provide ${doc.documentName}`,
                        })}
                        readOnly
                        value={getDocumentNamebyType(doc?.id)}
                      />
                    </>
                  )}
                  <span className="focus-border"></span>

                  <Button
                    onClick={() => {
                      handleInputClick(doc?.id);
                    }}
                    className="mt-3"
                  >
                    Select Document
                  </Button>
                </Form.Group>
              </div>
              {errors && errors[doc.id] && (
                <span className="text-danger">{errors[doc?.id]?.message}</span>
              )}
            </React.Fragment>
          )}
        </React.Fragment>
      ))}

      <Modal show={showModal} onHide={onClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Select Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <Form.Group className="col-6 mb-3">
              <Form.Label>Selected Unit :: </Form.Label>
              <Form.Label>{selectedTraderUnit?.name}</Form.Label>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Document Type</Form.Label>
              <Form.Select
                value={selectedDocumentType}
                onChange={handleDocumentTypeChange}
              >
                <option value="">Select Document Type</option>
                {documentTypes.map((documentType) => (
                  <option key={documentType?.id} value={documentType?.id}>
                    {documentType?.documentName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
            <div
              style={{
                display: "flex",
                padding: 10,
                columnGap: 20,
                flexWrap: "wrap",
              }}
            >
              {matchedDocument && matchedDocument.documentName && (
                <React.Fragment>
                  <div
                    style={{
                      textAlign: "center",
                      border: "1px solid #ec2f7c",
                      borderRadius: 5,
                      minWidth: 100,
                      marginTop: 10,
                      cursor: "pointer",
                      backgroundColor:
                        selectedDocument?.documentName ===
                        matchedDocument?.documentName
                          ? "#ffcccc"
                          : "",
                    }}
                    onClick={() => {
                      setRequiredDoc(matchedDocument);
                    }}
                  >
                    <div style={{ height: "70%", padding: 10 }}>
                      <img
                        style={{ width: 50, height: 50 }}
                        src="/assets/images/svg/filetype-pdf.svg"
                        alt="PDF"
                      />
                    </div>
                    <div
                      style={{
                        height: "30%",
                        backgroundColor: "#ec2f7c",
                        textAlign: "center",
                        padding: 5,
                      }}
                    >
                      <span
                        title={matchedDocument?.documentName}
                        style={{
                          color: "white",
                          display: "inline-block",
                          textOverflow: "ellipsis",
                          maxWidth: 200,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                        }}
                      >
                        {matchedDocument?.documentName}
                      </span>
                    </div>
                  </div>
                </React.Fragment>
              )}
              {!matchedDocument && (
                <>
                  <span className="text-danger">
                    No document found. Please add document to your selected unit
                    from manage units section.{" "}
                  </span>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default FoodHyigeneHealth;
